<form [formGroup]="getAuditsForm">
    <app-dropdown formControlName="entity"
                  [formControl]="getAuditsForm.controls['entity']"
                  [items]="entities"
                  valueField="value"
                  displayField="name"
                  [emptyText]="'admin.audits.form.placeholders.entity' | translate"
                  [showErrors]="showValidations"
                  (selectItem)="onEntityChange($event)">
    </app-dropdown>
    <app-input-datepicker
        [formControl]="getAuditsForm.controls['startDate']"
        appendTo="body"
        [placeholder]="'admin.audits.form.placeholders.startDate' | translate"
        [showErrors]="showValidations">
    </app-input-datepicker>

    <app-input-datepicker
        [formControl]="getAuditsForm.controls['endDate']"
        appendTo="body"
        [placeholder]="'admin.audits.form.placeholders.endDate' | translate"
        [showErrors]="showValidations">
    </app-input-datepicker>

    <app-button
        type="primary"
        class="download-btn"
        (click)="onDownload()">
        {{ 'admin.audits.form.downloadButton' | translate }}
    </app-button>
</form>
